import axios from 'axios';

export function formatDate(dateStr) {
    let date = new Date(Date.parse(dateStr));
    return [date.getDate().toString().padStart(2, '0'),
        (date.getMonth() + 1).toString().padStart(2, '0'),
        date.getFullYear()].join('/');
}

export function formatDateTime(dateStr) {
    let date = new Date(Date.parse(dateStr));
    return [date.getDate().toString().padStart(2, '0'),
            (date.getMonth() + 1).toString().padStart(2, '0'),
            date.getFullYear()].join('/') + ' ' +
        [date.getHours().toString().padStart(2, '0'),
            date.getMinutes().toString().padStart(2, '0')].join(':');
}

export function formatDateLong(dateStr) {
    let date = new Date(Date.parse(dateStr));
    const formatter = new Intl.DateTimeFormat('pt-br', {month: 'long'});
    return [date.getDate().toString().padStart(2, '0'),
            formatter.format(date),
            date.getFullYear()].join(' de ') + ', ' +
        [date.getHours().toString().padStart(2, '0'),
            date.getMinutes().toString().padStart(2, '0')].join(':');
}

export function getDateFromDateTime(date, time) {
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    let hour = time.getHours();
    let minute = time.getMinutes();
    let seconds = time.getSeconds();
    let milliseconds = time.getMilliseconds();
    return new Date(year, month, day, hour, minute, seconds, milliseconds);
}

export function formatTime(time) {
    return [time.getHours().toString().padStart(2, '0'),
        time.getMinutes().toString().padStart(2, '0')].join(':');
}

export function emailValidation(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export async function validateCep(zipCode) {
    if (zipCode.length === 9) {
        zipCode = zipCode.replace('-', '');
        let response = await axios.get(`https://viacep.com.br/ws/${zipCode}/json/`);
        return response.data
    }

    return null
}

export function setCookie(name, value, expiration) {
    let d = new Date();
    d.setTime(d.getTime() + expiration * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires;
}

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export function routeAuthentication(to, from, next) {
    if (!getCookie('authToken')) {
        window.location.assign(window.location.origin + '/#/login');
        window.location.reload();
    } else {
        if (getCookie('refresh')) {
            setCookie('refresh', 'true', 3600);
            setCookie('authToken', getCookie('authToken'), 3600);
        }
        next();
    }
}

export function routeAuthenticationAdmin(to, from, next) {
    let isLogged = getCookie('authToken');
    let isAdmin = !!getUserData().institutionSlug;

    if (!isLogged || !isAdmin) {
        cleanTokenCookie();
        window.location.assign(window.location.origin + '/#/login');
        window.location.reload();
    } else {
        if (getCookie('refresh')) {
            setCookie('refresh', 'true', 3600);
            setCookie('authToken', getCookie('authToken'), 3600);
        }
        next();
    }
}

export function setTokenCookie(data, response) {
    if (data.expires) {
        setCookie('authToken', response.data.token, 3600);
        setCookie('refresh', 'true', 3600);
    } else {
        setCookie('authToken', response.data.token, new Date(9999, 1, 1).toUTCString());
    }
}

export function cleanTokenCookie() {
    setCookie('authToken', '', 0);
    setCookie('refresh', '', 0);
}

export function getSlugFromName(name) {
    return name.toLowerCase()
        .normalize("NFD")
        .replace(/[^a-zA-Z0-9]/g, "")
}

export function setUserData(data) {
    localStorage.setItem('userData', JSON.stringify(data));
}

export function getUserData() {
    let data = localStorage.getItem('userData');
    return data ? JSON.parse(data) : {};
}

export function telephoneMask(value) {
    return !value || value.length <= 13 ? '(##)####-#####' : '(##)#####-####'
}

export function cvvMask(value) {
    return !value || value[0] !== '3' ? '###' : '####'
}

export function formatPrice(value) {
    value = parseFloat(value);
    const val = value.toFixed(2).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

export function formatDuration(value) {
    return `${Math.floor(value/60)}:${value % 60}`
}

export function validaCNPJ(cnpj) {
    let i;

    cnpj = cnpj.replace(/\./g, "");
    cnpj = cnpj.replace(/\//g, "");
    cnpj = cnpj.replace(/-/g, "");
    let c  = cnpj.substr(0,12);
    let dv = cnpj.substr(12,2);

    if (cnpj === "00000000000000"){
        return false;
    }

    let d1 = 0;
    let ms = "543298765432";

    for (i = 0; i < 12; i++) {
        d1 += c.charAt(i)*ms.charAt(i);
    }
    d1 = (d1 % 11);
    if (d1 == 0 || d1 == 1) {
        d1 = 0;
    } else {
        d1 = 11 - d1;
    }

    c = c + d1;

    let d2 = 0;
    ms = "6543298765432";
    for (i = 0; i < 13; i++) {
        d2 += c.charAt(i)*ms.charAt(i);
    }
    d2 = (d2 % 11);
    if (d2 == 0 || d2 == 1) {
        d2 = 0;
    } else {
        d2 = 11 - d2;
    }

    if (dv.charAt(0) != d1 || dv.charAt(1) != d2) {
        return false;
    }
    return true;
}

export function validaCPF(CPF) {
    let i;

    CPF = CPF.replace(/\./g, "");
    CPF = CPF.replace(/,/g, "");
    CPF = CPF.replace(/-/g, "");
    CPF = CPF.replace(/\//g, "");
    CPF = CPF.replace(/ /g, "");

    if (CPF.length !== 11 || CPF === "00000000000" || CPF === "11111111111" ||
        CPF === "22222222222" ||	CPF === "33333333333" || CPF === "44444444444" ||
        CPF === "55555555555" || CPF === "66666666666" || CPF === "77777777777" ||
        CPF === "88888888888" || CPF === "99999999999")
    {
        return false
    }
    let soma = 0;
    for (i=0; i < 9; i ++) {
        soma += parseInt(CPF.charAt(i)) * (10 - i);
    }
    let resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) {
        resto = 0;
    }
    if (resto !== parseInt(CPF.charAt(9))) {
        return false
    }
    soma = 0;
    for (i = 0; i < 10; i ++) {
        soma += parseInt(CPF.charAt(i)) * (11 - i);
    }
    resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) {
        resto = 0;
    }
    if (resto !== parseInt(CPF.charAt(10))) {
        return false
    }
    return true
}

export function adminToken(){
    return 'V3HI%5p8PA-'
}